export default __webpack_public_path__ + "static/media/JavaScript.3fde3095.svg";